import { Box, List, ListItem, ListSubheader } from "@mui/material";
import { red } from "@mui/material/colors";

import React from "react";

import { groupBy } from "lodash";
import { useHits } from "react-instantsearch-hooks-web";

import Hit from "./Hit";

import { CustomHit } from "../types";
import { getIcon } from "../utils";

const HitContainer = () => {
    const { hits } = useHits<CustomHit>();

    // const groupedHits = groupBy<CustomHit>(hits, (c) => c.type);
    const groupedHits = groupBy(hits, (c) => c.type);

    return (
        <List>
            <li>
                <ul>
                    {/* {map(groupedHits, (items, key) => {})} */}
                    {Object.keys(groupedHits).map((key) => {
                        const items = groupedHits[key];
                        const Icon = getIcon(key);

                        return (
                            <>
                                <ListSubheader
                                    sx={{
                                        background: red[50], // (theme) => theme.palette.primary.main,
                                        color: (theme) => theme.palette.typography.main,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        fontWeight: "bold",
                                        textTransform: "uppercase",
                                        py: 0,
                                        lineHeight: "unset"
                                    }}
                                    disableGutters
                                >
                                    <Box component="span" sx={{ ml: 1 }}>
                                        {key.toUpperCase()}
                                        {["experience"].includes(key.toLowerCase())
                                            ? ""
                                            : "S"}
                                    </Box>
                                </ListSubheader>
                                <>
                                    {items.map((hit) => (
                                        <ListItem
                                            key={hit.objectID}
                                            sx={{
                                                py: 0,
                                                width: "100%",
                                                mb: 0,
                                                mt: 0,
                                                margin: 0,
                                                alignItems: "flex-start"
                                            }}
                                            disableGutters
                                        >
                                            <Box
                                                sx={{
                                                    p: 1
                                                }}
                                            >
                                                <Icon />
                                            </Box>
                                            <Hit hit={hit} />
                                        </ListItem>
                                    ))}
                                </>
                            </>
                        );
                    })}
                </ul>
            </li>
        </List>
    );
};

export default HitContainer;
